export function cellAnimations() {
    const $window = $(window);
    const $items = $(".cell-animations");

    $window.on("scroll load", () => {
        $items.each((i, item) => {
            if ($window.scrollTop() > $(item).offset().top - $window.height() * .85 && !$(item).hasClass("animate")) {
                $(item).addClass("animate");
                $(item).find('.animate-item').each((i, item) => {
                    let src = item.getAttribute("data-json");
                    if (src) {
                        window.lottiejs.loadAnimation({
                            container: item,
                            path: src,
                            renderer: "svg",
                            loop: true
                        });
                    }
                });
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/cellAnimations.js